"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAncestor = isAncestor;
exports.isDesendant = isDesendant;
// For some general information about fiber we can refer to
// https://github.com/acdlite/react-fiber-architecture#return
function isAncestor(fromFiber, toFiber) {
  if (fromFiber === toFiber) {
    return false;
  }

  var currentNode = toFiber;

  // go up until there's no return fiber
  while (currentNode !== null) {
    if (currentNode === fromFiber) {
      return true;
    }

    currentNode = currentNode.return;
  }

  return false;
}

function isDesendant(fromFiber, toFiber) {
  if (fromFiber === toFiber) {
    return false;
  }

  return isAncestor(toFiber, fromFiber);
}